module.exports = __webpack_public_path__ + "static/media/STFU-3.315ab8e8.png";